import AtcFlightSegment from './flight-segment-component';
import AtcFlightSegmentService from './flight-segment-service';
import AtcFlightGroupModule from './flight-group/flight-group-module';
import AtcFlightSegmentDetailsFlightModule from './flight-segment-details-flight/flight-segment-details-flight-module';
import AtcFlightSegmentAlternativesModule from './flight-segment-alternatives/flight-segment-alternatives-module';

import './flight-segment.scss';

const MODULE_NAME = 'app.atc.flight.segment';
const module = angular.module(MODULE_NAME, [
        AtcFlightGroupModule,
        AtcFlightSegmentDetailsFlightModule,
        AtcFlightSegmentAlternativesModule,
    ])
    .directive(AtcFlightSegment.DIRECTIVE_NAME, AtcFlightSegment)
    .service('atcFlightSegmentService', AtcFlightSegmentService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/atc/atc-flights-view/flight-recommendation/flight-segment/flight-segment-module.js